module.exports = __webpack_public_path__ + "beauty-model-desktop-71e5bb.webp";